import { Injectable } from '@angular/core';
import { ApiClientService } from 'src/app/stp/stp-app/api-client';
import { EcNumberLinkingResult } from './models/ecNumberLinkingResult.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {

  constructor(private apiClient: ApiClientService) {
  }

  public autoLinkEcNumber(): Observable<EcNumberLinkingResult> {
    return this.apiClient.put<EcNumberLinkingResult>('autoLinkEcNumber', null);
  }

  public resendVerificationEmail(auth0UserId: string) {
    return this.apiClient.post(auth0UserId + '/resendVerificationEmail', null);
  }

  public updateProfile() {
    // Just post to profile end point. API token with profile details automatically
    // attached to every request
    return this.apiClient.post('profile', null);
  }
}
